import {CreatedImage} from '../resources/CreatedImage';
import {DomainEvent} from './DomainEvent';

export class ImageCreated extends DomainEvent<CreatedImage> {}
